<div>
  <h1 mat-dialog-title>IKTVA data was submitted successfully</h1>
  <div mat-dialog-content>
    <p>Your LCGPA form id is: <b>{{data.iktvaFormData?.UniqueIktvaId}}</b></p>
    <p>Confirmation email will be sent to {{data.iktvaFormData?.EmailContactPerson}}</p>
  </div>
  <div>
    <button mat-raised-button color="primary" (click)="onOkClick()">Ok</button>
  </div>
</div>
